import type { Result } from './result-flow'
import { r } from './result-flow'

export type Variant = {
	name: string,
	sizeBytes: number
}

export type Release = {
	name: string,
	patchNotes: string | null,
	variants: Variant[]
}

async function parseResult (res: Response): Promise<Result> {
	const json = await res.json().catch(() => null)
	if (!r.isResult(json)) return r.fail('Invalid response from server')
	return json
}

export const api = {
	async submitAccessCode (code: string): Promise<Result> {
		const res = await fetch('/api/auth/access', {
			method: 'POST',
			credentials: 'include',
			headers: { 'content-type': 'application/json' },
			body: JSON.stringify({ code })
		})
		return parseResult(res)
	},

	async logout (): Promise<Result> {
		const res = await fetch('/api/auth/access', {
			method: 'DELETE',
			credentials: 'include'
		})
		return parseResult(res)
	},

	async fetchReleases (): Promise<Result<Release[]>> {
		const res = await fetch('/api/releases', { credentials: 'include' })
		if (res.status === 401) {
			return r.fail('Unauthorized')
		}
		return parseResult(res) as Promise<Result<Release[]>>
	},

	downloadVariantUrl (releaseName: string, variant: string): string {
		return `/api/releases/${encodeURIComponent(releaseName)}/${encodeURIComponent(variant)}`
	},

	async downloadVariant (releaseName: string, variant: string): Promise<void> {
		const res = await fetch(api.downloadVariantUrl(releaseName, variant), { credentials: 'include' })
		if (!res.ok) {
			console.error('Download failed', res.status)
			return
		}
		const blob = await res.blob()
		const url = URL.createObjectURL(blob)
		const a = document.createElement('a')
		a.href = url
		a.download = `${variant}.zip`
		document.body.appendChild(a)
		a.click()
		document.body.removeChild(a)
		URL.revokeObjectURL(url)
	}
}
